import { DownloadLink } from "src/models";

export const AppBox: React.FC<DownloadLink> = ({ logo, title, url }) => {

  const finalUrl =
    url.indexOf("http://") > -1 ||
    url.indexOf("https://") > -1 ||
    (url.indexOf("#") > -1 && url.length === 1)
      ? url
      : `https://${url}`;

  return (
    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
      <div className="download-tile">
        <img src={logo} alt={title} />
        <a
          className="btn btn-submit"
          href={finalUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </a>
      </div>
    </div>
  );
};
